import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { O5_ENVIRONMENT_BASE_PATH } from '../../../../../../features/o5/environment/o5-environment-routing';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/environment/_environment')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'o5-environment-list',
        label: 'Environments',
        to: O5_ENVIRONMENT_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
